import { Payment } from './payment';
import { ProductShoppingCar } from './productShoppingCar';

export class Purchase2 {

  id: number;
  clientId: number;
  clientName: string; 
  clientAddress: string; 
  deliveryPrice: number;
  deliveryTime: number;
  deliveryId: number;
  discount: number;
  observation: string;
  orderTypeId: number;
  orderTypeDescription: string;
  subtotal: number;
  tax: number;
  total: number;
  userAddressId: number;
  userCurrentAddress: string;
  userId: number;
  wayToPayId: number;
  wayToPayName: string;
  paymentStatus: string;
  tipPrice: number;
  bigTotal: number;

  paymentMethods: Payment[];
  products: ProductShoppingCar[];

	constructor( p ?: any ) {
    this.id = p ? p.id: null;
    this.clientId = p ? p.client_id: null;
    this.clientName = p ? p.client_name: null;
    this.clientAddress = p ? p.client_address: null;
    this.deliveryPrice = p ? p.delivery_price: null;
    this.deliveryTime = p ? p.delivery_time: null;
    this.deliveryId = p ? p.delivery_id: null;
    this.discount = p ? p.discount: null;
    this.observation = p ? p.observation: null;
    this.orderTypeId = p ? p.order_type_id: null;
    this.orderTypeDescription = p ? p.order_type_description: null;
    this.subtotal = p ? p.subtotal: null;
    this.tax = p ? p.tax: null;
    this.total = p ? p.total: null;
    this.userAddressId = p ? p.user_address_id: null;
    this.userCurrentAddress = p ? p.user_current_address: null;
    this.userId = p ? p.user_id: null;
    this.wayToPayId = p ? p.way_to_pay_id: null;
    this.wayToPayName = p ? p.way_to_pay_name: null;
    this.paymentStatus = p ? p.payment_status: null;
    this.tipPrice = p ? p.tip_price: null;
    this.bigTotal = 0;

    this.paymentMethods = p ? new Payment().mapPayment(p.formas_pago) : [];
    this.products = p ? new ProductShoppingCar().mapProduct(p.detalles) : [];
  }
  
  mapPurchase(list: any[]): Purchase2[] {
    let newList: Purchase2[] = [];
    list.forEach((item: any) => {
      let newItem: Purchase2 = new Purchase2(item);
      newList.push(newItem);
    });
    return newList;
  }

}
